import { create } from "zustand";

interface IsCompactViewActions {
  initListener: () => void;
  disposeListener: () => void;
}

interface IsCompactViewStore {
  isCompactView: boolean;

  actions: IsCompactViewActions;
}

const useIsCompactViewStore = create<IsCompactViewStore>((set) => {
  const checkMobile = () => {
    set({ isCompactView: window.innerWidth <= 900 });
  };

  return {
    isCompactView: false,

    actions: {
      initListener: () => {
        checkMobile();
        window.addEventListener("resize", checkMobile);
      },

      disposeListener: () => {
        window.removeEventListener("resize", checkMobile);
      },
    },
  };
});

export const useIsCompactView = () =>
  useIsCompactViewStore((state) => state.isCompactView);

export const useIsCompactViewActions = () =>
  useIsCompactViewStore((state) => state.actions);
